// baseClient.ts

export interface AiClient {
  appName: string;
  icon: string;
  send(message: string): Promise<any>;
  stream?(message: string, onMessage: (msg: any) => void): void;
  close?(): void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type MessageType = any;
